import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle, Home, FileText } from "lucide-react";

interface SubmissionSuccessDialogProps {
  open: boolean;
  onClose: () => void;
  onReturnToDashboard: () => void;
  onViewProposal: () => void;
}

const SubmissionSuccessDialog = ({
  open,
  onClose,
  onReturnToDashboard,
  onViewProposal,
}: SubmissionSuccessDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="p-4 rounded-full bg-green-100">
              <CheckCircle className="h-12 w-12 text-green-600" />
            </div>
          </div>
          <DialogTitle className="text-2xl text-center">Proposal Submitted!</DialogTitle>
          <DialogDescription className="text-center text-base">
            Your proposal has been successfully submitted. You will be notified when the auction begins.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-3 mt-4">
          <Button onClick={onViewProposal} className="w-full gap-2">
            <FileText className="h-4 w-4" />
            View My Proposal
          </Button>
          <Button onClick={onReturnToDashboard} variant="outline" className="w-full gap-2">
            <Home className="h-4 w-4" />
            Return to Dashboard
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SubmissionSuccessDialog;
